import { Search } from 'lucide-react'
import type { Ref } from 'react'

import { TranslationKeys } from '@/@types/keys/translation'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import useTranslator from '@/hooks/translation'
import { cn } from '@/lib/utils'

import { SearchInputProps } from './types'

type Props = SearchInputProps & {
  ref?: Ref<HTMLInputElement>
}

function SearchInput({
  ref,
  className,
  inputClassName,
  placeholder,
  onChange,
  value = '',
  name,
  id,
  type = 'text',
  ...props
}: Props) {
  const { getTranslation } = useTranslator()

  return (
    <div
      className={cn(
        'relative flex h-11 w-full min-w-[220px] items-center rounded-2xl shadow-md',
        className,
      )}
    >
      <Button
        type="button"
        variant="ghost"
        className="absolute left-2 h-fit w-fit p-2 hover:bg-transparent"
      >
        <Search className="text-muted-foreground" />
      </Button>

      <Input
        ref={ref}
        type={type}
        placeholder={`${placeholder ? `${getTranslation(placeholder as TranslationKeys)}` : ''}`}
        className={cn(
          'h-full w-full rounded-2xl pl-11 focus-visible:ring-0 focus-visible:ring-offset-0 [&::placeholder]:text-[15px] [&::placeholder]:font-normal [&::placeholder]:leading-6 [&::placeholder]:tracking-[0px]',
          inputClassName,
        )}
        value={value}
        name={name}
        id={id}
        onChange={onChange}
        aria-label="Search input"
        {...props}
      />
    </div>
  )
}

export { SearchInput }
